import { Component, OnInit } from '@angular/core';
import { GestionProvenanceService } from '../../services/navigation/gestion-provenance.service';

@Component({
  selector: 'app-bouton-retour-parcours-externe',
  templateUrl: './bouton-retour-parcours-externe.component.html',
  standalone: false,
})
export class BoutonRetourParcoursExterneComponent implements OnInit {
  urlRetourParcoursExterne: string;

  constructor(private readonly gestionProvenanceService: GestionProvenanceService) {}

  ngOnInit() {
    this.urlRetourParcoursExterne = this.gestionProvenanceService.obtenirRouteExterne();
  }
}
